export const PROFILE= "All Profiles"

export const  PROFILE_PAGES = {
    LOCATION_PLAN: "location-plan",
    LOCATION_DETAIL_VIEW: "location-detail-view",
}
// tooltip names
export const BACK = "Back to Menu"
